import {TweenMax} from "gsap";
import {TimelineMax} from "gsap";
import ScrollMagic from "scrollmagic";
import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';
import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators';
const controller = new ScrollMagic.Controller;
/**
 * headerScroll
 * @constructor
 */
class HeaderScroll {
  constructor() {}
  /**
   * コモン
   */
  init() {
    
    //コンパクトヘッダー
    const conpact_header = new TimelineMax();
    conpact_header.to('.l-conpact-header', 0.5, {
      y: '0',
      ease: Power1.easeInOut,
    })
    new ScrollMagic.Scene({
      triggerElement: '.l-main',
      triggerHook: '0',
      offset: '200',
      duration: '0',
      reverse: true,
    })
    .setTween(conpact_header)
//    .addIndicators({name: "conpact_header"})
    .addTo(controller);
    
    
    //コンパクトヘッダー
    const header_sp = new TimelineMax();
    new ScrollMagic.Scene({
      triggerElement: '.l-main',
      triggerHook: '0',
      offset: '100',
      duration: '0',
      reverse: true,
    })
    .setTween(header_sp)
    .setClassToggle('.l-header-sp', 'scroll')
//    .addIndicators({name: "header_sp"})
    .addTo(controller);
    
    //header メニューボタン sp 
    $('.js-menu-btn').on('click', function () {
      $('.l-header-sp__nav,.l-header-sp__inner,.l-header-sp__menu').toggleClass('active');
      if($('.l-header-sp__nav').hasClass('active')){
        $('body').css('position','fixed');
        $('.l-header-sp__nav').show();
        $('.l-header-sp__menu-language').show();
        $('.l-header-sp__menu-btn a img').attr('src','/corporate/assets/img/header/header_menubtn_close.svg');
      } else {
        $('body').css('position','relative');
        $('.l-header-sp__nav').hide();
        $('.l-header-sp__menu-language').hide();
        $('.l-header-sp__menu-btn a img').attr('src','/corporate/assets/img/header/header_menubtn.svg');
      }
    })
    
   
    
    
  }

}

export default HeaderScroll;
